const is_money = (money) => {
  const currency = money <= 0 ? 0 : money;
  return Number(currency).toLocaleString("en-NG", {
    style: "currency",
    currency: "NGN",
  });
};
export default is_money;
